export const UNBINNED = "__unbinned__" as const;

export const MAX_AUTO_TABS = 5;
